import { client } from 'helpers/client'

class ProductService {
    getAll = () => {
        return client('/CustomerProduct/GetAllCustomerProducts')
    }
    getById = (VersionSubscriptionId)=> {
        return client('/CustomerProduct/GetCustomerProduct',{params:{VersionSubscriptionId:VersionSubscriptionId}})
    }
    getChangeRequests = (versionSubscription)=>{
        return client(`/CustomerProduct/CustomerRequestChangeDevice`,{params:versionSubscription})
     }
    getAppLicenses = (versionSubscription)=>{
       return client(`/CustomerProduct/GetCustomerProductLicencesPagedList`,{params:versionSubscription})
    }
    getLicenses = (VersionSubscriptionId)=>{
        return client(`/CustomerProduct/GetVersionLicencesLookup`,{params:{VersionSubscriptionId:VersionSubscriptionId}}) 
    }
    renewActivationLicense=(productDevice)=>{
        return client('/CustomerProduct/ReNewActivationLicense', { data: productDevice })
    }
    renewAddonActivationLicense=(productDevice)=>{
        return client('/CustomerProduct/CreateCustomerAddOnLicense', { data: productDevice })
    }
    renewAddonExpire  = (productDevice)=>{
        return client('/CustomerProduct/ReNewAddOnActivationLicense', { data: productDevice })
    }
    // cancellAddonSubscription = (addonDevice)=>{
    //     return client('/CustomerProduct/CancelAddonSubscription', { data: addonDevice })
    // }
    getReasons = ()=>{
        return client(`/CustomerProduct/GetReasonChangeDevice`)
     }
    getAppAddon = (id)=>{
        return client(`/CustomerProduct/CustomerProductAddOn`,{params:{VersionSubscriptionId:id}})
    }
    getAddonById = (id)=>{
        return client(`/CustomerProduct/GetProductAddonDetails`,{params:{addonSubscriptionId:id}})

    }
    getAppReleases = (id)=>{
        return client(`/CustomerProduct/CustomerProductReleases`,{params:{VersionSubscriptionId:id}})
    }
    sendReleaseDownloadReq = (releaseBody)=>{
        return client('/CustomerProduct/VersionReleaseDownload', { data: releaseBody })
    }
    createDevice = (productDevice) => {
        return client('/CustomerProduct/CreateCustomerProductLicense', { data: productDevice })
    }

    updateDevice = (productDevice) => {
        return client('/CustomerProduct/UpdateCustomerProductLicense', { data: productDevice })
    }
    getCustomerSubscription = (VersionSubscriptionId) => {
        return client('/CustomerProduct/GetCustomerSubscription',{params:{VersionSubscriptionId:VersionSubscriptionId}})
    }
    updateCustomerSubscription = (subscription) => {
        return client('/CustomerProduct/UpdateCustomerSubscription', { data: subscription })
    }

    delete(productId) {
        return client('/delete', { params: { id: productId }, method: 'POST' })
    }
}

const _productService = new ProductService()

export default _productService

